import * as React from "react";
import { Input, Textarea, Label } from "./FormStyles";
import { warning } from "./Warning";

export const TextInput = props => {
  let { value, setValue, showWarning, label, warningLabel, isTextArea, subLabel, placeholder, type, isEmail } = props;
  let input = isTextArea ? (
    <Textarea
      placeholder={placeholder}
      value={value}
      onChange={event => setValue(event.target.value)}
      type={type ? type : "text"}
    />
  ) : (
    <Input
      placeholder={placeholder}
      value={value}
      onChange={event => setValue(event.target.value)}
      type={type ? type : "text"}
      name={isEmail ? 'email' : ''}
      data-cy="all-inputs"
    />
  );
  return (
    <React.Fragment>
      <Label>
        {label}
        {input}
      </Label>
      {subLabel}
      {warning(showWarning, warningLabel)}
    </React.Fragment>
  );
};

export const TextInputProps = (
  value,
  setValue,
  showWarning,
  label,
  warningLabel = "",
  isTextArea = false,
  subLabel = <React.Fragment />,
  placeholder = ""
) => ({
  value,
  setValue,
  showWarning,
  label,
  warningLabel,
  isTextArea,
  subLabel,
  placeholder
});
